import { ROUTES as AUTH_ROUTE_NAMES } from '../auth/routes'
import { ROUTE_NAMES as BUY_BACK_ROUTE_NAMES } from '../buyback/constants'
import { CHECKOUT as CHECKOUT_ROUTE_NAMES } from '../checkout/routes-names'

export const DO_NOT_DISTURB_ROUTE_NAMES = [
  BUY_BACK_ROUTE_NAMES,
  CHECKOUT_ROUTE_NAMES,
  AUTH_ROUTE_NAMES,
]
